import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Navbar, Nav, Container } from 'react-bootstrap';
import './Header.css';

const Header: React.FC = () => {
  const [expanded, setExpanded] = useState(false);

  return (
    <header className="fixed-top">
      <div className="top-brand-bar text-center">
        <Link className="navbar-brand" to="/event-details" onClick={() => setExpanded(false)}>
          <img src="/images/double_palm.png" alt="Palm Tree" className="palm-image" />
          <div>Lance & Morgan</div>
        </Link>
      </div>
      <Navbar expanded={expanded} onToggle={() => setExpanded(!expanded)} expand="lg" variant="light">
        <Container>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="mx-auto">
              <Nav.Link as={Link} to="/event-details" onClick={() => setExpanded(false)}>Event Details</Nav.Link>
              <Nav.Link as={Link} to="/our-story" onClick={() => setExpanded(false)}>Our Story</Nav.Link>
              <Nav.Link as={Link} to="/rsvp" onClick={() => setExpanded(false)}>RSVP</Nav.Link>
              <Nav.Link as={Link} to="/registry" onClick={() => setExpanded(false)}>Registry</Nav.Link>
              <Nav.Link as={Link} to="/cashew-ai" onClick={() => setExpanded(false)}>CashewAI</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
  );
};

export default Header;
